// import React, { useState } from "react";
// import { CreateContact } from "../../Apiservice";
// import { Link } from "react-router-dom";
// import { Footer } from "../navbar/Footer";
// import { motion } from "framer-motion";  // Importing framer-motion for animations

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     mobile: "",
//     address: "",
//     subject: "",
//     message: "",
//   });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [success, setSuccess] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError(null);
//     setSuccess(false);

//     try {
//       const response = await CreateContact(formData);
//       console.log("Form submitted successfully:", response);
//       setSuccess(true);
//       // Clear the form
//       setFormData({
//         name: "",
//         email: "",
//         mobile: "",
//         address: "",
//         subject: "",
//         message: "",
//       });
//     } catch (error) {
//       console.error("There was an error submitting the form:", error);
//       setError("There was an error submitting the form. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div>
//       <motion.div
//         className="page-title dark-background"
//         style={{ backgroundImage: "url(/assets/img/Bannerimages/Contact.jpg)" }}
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         transition={{ duration: 1 }}
//       >
//         <div className="container position-relative">
//           <h1 className="works-banner">Contact</h1>
//           <nav className="breadcrumbs">
//             {/* <ol>
//               <li><Link to="/">Home</Link></li>
//               <li className="current">Contact</li>
//             </ol> */}
//           </nav>
//         </div>
//       </motion.div>

//       <section id="contact" className="contact section">
//         <div className="container">
//           <div className="row gy-4">
//           <motion.div
//               className="col-lg-6"
//               initial={{ x: -100 }}
//               animate={{ x: 0 }}
//               transition={{ type: "spring", duration: 0.5 }}
//             >
//               <div className="info-item d-flex flex-column justify-content-center align-items-center">
//                 <i className="bi bi-geo-alt"></i>
//                 <h3>Address</h3>
//                 <p>MIG - 462, Old ASTC Hudco, Hosur - 635 109.</p>
//                 <p>27/G5, Kuttiyan St lane, Kumbakonam - 612 001.</p>
//               </div>
//             </motion.div>

//             <motion.div
//               className="col-lg-3 col-md-6"
//               initial={{ y: -100 }}
//               animate={{ y: 0 }}
//               transition={{ type: "spring", duration: 0.5 }}
//             >
//               <div className="info-item d-flex flex-column justify-content-center align-items-center">
//                 <i className="bi bi-telephone"></i>
//                 <h3>Call Us</h3>
//                 <p>
//                   <Link to="tel:+919488972821">+91 94889 72821</Link> /{" "}
//                   <Link to="tel:+918124850138">+91 81248 50138</Link>
//                 </p>
//               </div>
//             </motion.div>

//             <motion.div
//               className="col-lg-3 col-md-6"
//               initial={{ y: 100 }}
//               animate={{ y: 0 }}
//               transition={{ type: "spring", duration: 0.5 }}
//             >
//               <div className="info-item d-flex flex-column justify-content-center align-items-center">
//                 <i className="bi bi-envelope"></i>
//                 <h3>Email Us</h3>
//                 <p>
//                   <Link to="mailto:vogelkop.architects@gmail.com" target="blank">
//                     vogelkop.architects@gmail.com
//                   </Link>
//                 </p>
//               </div>
//             </motion.div>
//             <motion.div
//               className="col-lg-6"
//               initial={{ x: -100 }}
//               animate={{ x: 0 }}
//               transition={{ type: "spring", duration: 0.5 }}
//             >
//               <iframe
//                 src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15566.644520326765!2d77.8193351!3d12.735516!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae7110a65f0505%3A0x235b21d049e35c2!2sVogelkop%20Architects!5e0!3m2!1sen!2sin!4v1720089674719!5m2!1sen!2sin"
//                 frameborder="0"
//                 style={{ width: "100%", height: "400px" }}
//                 allowfullscreen=""
//                 loading="lazy"
//                 referrerpolicy="no-referrer-when-downgrade"
//                 title="Vogelkop Architects Location Map"
//               ></iframe>
//             </motion.div>

//             <motion.div
//               className="col-lg-6"
//               initial={{ x: 100 }}
//               animate={{ x: 0 }}
//               transition={{ type: "spring", duration: 0.5 }}
//             >
//               <iframe
//                 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3917.086880732758!2d79.35556557408988!3d10.956809655842548!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3baacd1c2c3e599b%3A0x51302927df087a98!2sVOGELKOP%20ARCHITECTS!5e0!3m2!1sen!2sin!4v1741069501152!5m2!1sen!2sin"
//                 frameborder="0"
//                 style={{ width: "100%", height: "400px" }}
//                 allowfullscreen=""
//                 loading="lazy"
//                 referrerpolicy="no-referrer-when-downgrade"
//                 title="Second Vogelkop Architects Location Map"
//               ></iframe>
//             </motion.div>
//           </div>

//           <div className="row gy-4 mt-1">
//             <motion.div
//               className="col-lg-12"
//               initial={{ scale: 0.8 }}
//               animate={{ scale: 1 }}
//               transition={{ duration: 0.5 }}
//             >
//               <form onSubmit={handleSubmit} className="php-email-form">
//                 <div className="row">
//                   <div className="col-md-6 form-group">
//                     <input
//                       type="text"
//                       name="name"
//                       className="form-control"
//                       placeholder="Your Name"
//                       value={formData.name}
//                       onChange={handleChange}
//                       required
//                     />
//                   </div>
//                   <div className="col-md-6 form-group">
//                     <input
//                       type="email"
//                       name="email"
//                       className="form-control"
//                       placeholder="Your Email"
//                       value={formData.email}
//                       onChange={handleChange}
//                       required
//                     />
//                   </div>
//                 </div>
//                 <div className="form-group mt-3">
//                   <input
//                     type="text"
//                     name="mobile"
//                     className="form-control"
//                     placeholder="Contact Number"
//                     value={formData.mobile}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>
//                 <div className="form-group mt-3">
//                   <input
//                     type="text"
//                     name="address"
//                     className="form-control"
//                     placeholder="Your Address"
//                     value={formData.address}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>
//                 <div className="form-group mt-3">
//                   <textarea
//                     name="message"
//                     className="form-control"
//                     rows="5"
//                     placeholder="Message"
//                     value={formData.message}
//                     onChange={handleChange}
//                     required
//                   ></textarea>
//                 </div>
//                 {loading && <div className="loading">Loading...</div>}
//                 {error && <div className="error-message">{error}</div>}
//                 {success && (
//                   <div className="sent-message">
//                     Your message has been sent. Thank you!
//                   </div>
//                 )}
//                 <div className="text-center mt-3">
//                   <button type="submit" disabled={loading}>
//                     {loading ? "Sending..." : "Send Message"}
//                   </button>
//                 </div>
//               </form>
//             </motion.div>
//           </div>
//         </div>
//       </section>
//       <Footer />
//     </div>
//   );
// };

import React, { useState, useEffect, useRef } from "react";
import { CreateContact } from "../../Apiservice";
import { Link } from "react-router-dom";
import { Footer } from "../navbar/Footer";
import { motion } from "framer-motion";
import "./Works.css"; // Import Works.css for the works-hero styling

const Contact = () => {
  const sliderRef = useRef(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    address: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  // Careers State
  const [careers, setCareers] = useState([]);
  const [careerLoading, setCareerLoading] = useState(true);

  // Fetch Careers API
  useEffect(() => {
    fetch("https://vogelkoparchitects.com/api/api/careers/")
      .then((res) => res.json())
      .then((data) => {
        setCareers(data);
        setCareerLoading(false);
      })
      .catch((err) => {
        console.error("Career API Error:", err);
        setCareerLoading(false);
      });
  }, []);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: -400,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: 400,
        behavior: "smooth",
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await CreateContact(formData);

      console.log("Form submitted successfully:", response);

      setSuccess(true);

      setFormData({
        name: "",
        email: "",
        mobile: "",
        address: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      console.error("There was an error submitting the form:", error);

      setError("There was an error submitting the form. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Banner */}
      <motion.div
        className="works-hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div 
          className="works-hero-bg" 
          style={{ backgroundImage: "url(/assets/img/Bannerimages/Contact.jpg)" }}
        >
          <div className="works-hero-overlay"></div>
        </div>
        <div className="works-hero-content">
          <h1 className="works-hero-title">Contact</h1>
        </div>
      </motion.div>

      {/* Contact Section */}
      <section id="contact" className="contact section">
        <div className="container">
          <div className="row gy-4">
            {/* Address */}
            <motion.div
              className="col-lg-6"
              initial={{ x: -100 }}
              animate={{ x: 0 }}
              transition={{ type: "spring", duration: 0.5 }}
            >
              <div className="info-item d-flex flex-column justify-content-center align-items-center">
                <i className="bi bi-geo-alt"></i>

                <h3>Address</h3>

                <p>MIG - 462, Old ASTC Hudco, Hosur - 635 109.</p>

                <p>27/G5, Kuttiyan St lane, Kumbakonam - 612 001.</p>
              </div>
            </motion.div>

            {/* Phone */}
            <motion.div
              className="col-lg-3 col-md-6"
              initial={{ y: -100 }}
              animate={{ y: 0 }}
              transition={{ type: "spring", duration: 0.5 }}
            >
              <div className="info-item d-flex flex-column justify-content-center align-items-center">
                <i className="bi bi-telephone"></i>

                <h3>Call Us</h3>

                <p>
                  <Link to="tel:+919488972821">+91 94889 72821</Link> /{" "}
                  <Link to="tel:+918124850138">+91 81248 50138</Link>
                </p>
              </div>
            </motion.div>

            {/* Email */}
            <motion.div
              className="col-lg-3 col-md-6"
              initial={{ y: 100 }}
              animate={{ y: 0 }}
              transition={{ type: "spring", duration: 0.5 }}
            >
              <div className="info-item d-flex flex-column justify-content-center align-items-center">
                <i className="bi bi-envelope"></i>

                <h3>Email Us</h3>

                <p>
                  <Link
                    to="mailto:vogelkop.architects@gmail.com"
                    target="blank"
                  >
                    vogelkop.architects@gmail.com
                  </Link>
                </p>
              </div>
            </motion.div>

            {/* Map 1 */}
            <motion.div
              className="col-lg-6"
              initial={{ x: -100 }}
              animate={{ x: 0 }}
              transition={{ type: "spring", duration: 0.5 }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15566.644520326765!2d77.8193351!3d12.735516!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae7110a65f0505%3A0x235b21d049e35c2!2sVogelkop%20Architects!5e0!3m2!1sen!2sin!4v1720089674719!5m2!1sen!2sin"
                frameBorder="0"
                style={{ width: "100%", height: "400px" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Vogelkop Architects Location Map"
              ></iframe>
            </motion.div>

            {/* Map 2 */}
            <motion.div
              className="col-lg-6"
              initial={{ x: 100 }}
              animate={{ x: 0 }}
              transition={{ type: "spring", duration: 0.5 }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3917.086880732758!2d79.35556557408988!3d10.956809655842548!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3baacd1c2c3e599b%3A0x51302927df087a98!2sVOGELKOP%20ARCHITECTS!5e0!3m2!1sen!2sin!4v1741069501152!5m2!1sen!2sin"
                frameBorder="0"
                style={{ width: "100%", height: "400px" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Second Vogelkop Architects Location Map"
              ></iframe>
            </motion.div>
          </div>

          {/* Contact Form */}
          <div className="row gy-4 mt-1">
            <motion.div
              className="col-lg-12"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.5 }}
            >
              <form onSubmit={handleSubmit} className="php-email-form">
                <div className="row">
                  <div className="col-md-6 form-group">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-md-6 form-group">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Your Email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-group mt-3">
                  <input
                    type="text"
                    name="mobile"
                    className="form-control"
                    placeholder="Contact Number"
                    value={formData.mobile}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group mt-3">
                  <input
                    type="text"
                    name="address"
                    className="form-control"
                    placeholder="Your Address"
                    value={formData.address}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group mt-3">
                  <textarea
                    name="message"
                    className="form-control"
                    rows="5"
                    placeholder="Message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                {loading && <div className="loading">Loading...</div>}

                {error && <div className="error-message">{error}</div>}

                {success && (
                  <div className="sent-message">
                    Your message has been sent. Thank you!
                  </div>
                )}

                <div className="text-center mt-3">
                  <button type="submit" disabled={loading}>
                    {loading ? "Sending..." : "Send Message"}
                  </button>
                </div>
              </form>
            </motion.div>
          </div>

          {/* Careers Section */}
          <div className="row mt-5">
            <div className="col-lg-12">
              <motion.div
                initial={{ opacity: 0, y: 80 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
              >
                {/* Heading */}
                <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
                  <div>
                    <h2
                      style={{
                        fontWeight: "600",
                        marginBottom: "10px",
                      }}
                    >
                      Careers
                    </h2>

                    <p>
                      Join our creative team and build inspiring architectural
                      experiences with Vogelkop Architects.
                    </p>
                  </div>

                  {/* Slider Buttons */}
                  <div className="d-flex gap-2">
                    <button
                      onClick={scrollLeft}
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        border: "none",
                        background: "#1e2a78",
                        color: "#fff",
                        fontSize: "22px",
                        cursor: "pointer",
                      }}
                    >
                      ←
                    </button>

                    <button
                      onClick={scrollRight}
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        border: "none",
                        background: "#1e2a78",
                        color: "#fff",
                        fontSize: "22px",
                        cursor: "pointer",
                      }}
                    >
                      →
                    </button>
                  </div>
                </div>

                {careerLoading ? (
                  <div className="text-center">
                    <p>Loading careers...</p>
                  </div>
                ) : (
                  <div
                    ref={sliderRef}
                    className="d-flex overflow-auto pb-3"
                    style={{
                      gap: "20px",
                      scrollBehavior: "smooth",
                      scrollbarWidth: "none",
                      msOverflowStyle: "none",
                    }}
                  >
                    {careers.map((career) => (
                      <div
                        key={career.id}
                        style={{
                          minWidth: "380px",
                          maxWidth: "380px",
                          flex: "0 0 auto",
                        }}
                      >
                        <motion.div
                          whileHover={{ y: -5 }}
                          className="p-4"
                          style={{
                            border: "1px solid #e5e5e5",
                            borderRadius: "14px",
                            background: "#fff",
                            height: "100%",
                            boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                          }}
                        >
                          <h4
                            style={{
                              fontWeight: "600",
                              marginBottom: "15px",
                            }}
                          >
                            {career.job_title}
                          </h4>

                          <div
                            style={{
                              color: "#666",
                              marginBottom: "20px",
                              lineHeight: "1.8",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: career.job_description,
                            }}
                          />

                          <a
                            href={career.apply_link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: "inline-block",
                              padding: "10px 25px",
                              background: "#1e2a78",
                              color: "#fff",
                              borderRadius: "30px",
                              textDecoration: "none",
                              fontWeight: "500",
                              transition: "0.3s",
                            }}
                          >
                            Apply Now
                          </a>
                        </motion.div>
                      </div>
                    ))}
                  </div>
                )}
              </motion.div>
            </div>

            {/* Hide Scrollbar */}
            <style>
              {`
                .overflow-auto::-webkit-scrollbar {
                  display: none;
                }
              `}
            </style>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;